module.exports = __webpack_public_path__ + "static/img/2-3.b7723c74.jpg";